import React from 'react';
import { FaArrowUp, FaArrowDown } from 'react-icons/fa';
import { formatValue, getNestedValue } from '../utils/formatters';

const StatRenderer = ({ data, config }) => {
  if (!data) return null;

  const { dataMapping = {}, format = 'number' } = config;
  const value = getNestedValue(data, dataMapping.value);
  const change = dataMapping.change ? getNestedValue(data, dataMapping.change) : null;
  const subtitle = dataMapping.subtitle ? getNestedValue(data, dataMapping.subtitle) : null;

  const changeNum = change !== null ? parseFloat(change) : null;
  const isPositive = changeNum !== null && changeNum >= 0;

  return (
    <div className="flex flex-col items-center justify-center h-full py-4">
      <p className="text-3xl font-bold text-gray-900">
        {formatValue(value, format)}
      </p>
      {subtitle && (
        <p className="text-sm text-gray-500 mt-1">{subtitle}</p>
      )}
      {changeNum !== null && (
        <div className={`flex items-center mt-2 px-2 py-1 rounded text-sm font-medium ${
          isPositive ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
        }`}>
          {isPositive ? <FaArrowUp className="w-3 h-3 mr-1" /> : <FaArrowDown className="w-3 h-3 mr-1" />}
          {Math.abs(changeNum).toFixed(1)}%
        </div>
      )}
    </div>
  );
};

export default StatRenderer;
